import { createGlobalStyle } from "styled-components";

import { fontWeights, typography } from "./font";
import palette from "./palette";

const cssVars = (vars: Record<string, unknown>) =>
  Object.entries(vars).reduce(
    (prev, [name, value]) => ` ${prev} --${name}: ${value};`,
    ""
  );

const GlobalStyle = createGlobalStyle`
    :root {
       --font-family: 'Heebo', sans-serif;

       ${cssVars({
         ...fontWeights,
         ...typography,
         ...palette,
       })}
    }

    button,
    input,
    select,
    textarea, h1, h2, h3, h4, h5, h6 {
      margin: 0;
      border: 0;
      padding: 0;
      font: inherit;
      font-size: 100%;
      vertical-align: baseline;
    }

    *, ::before, ::after {
      line-height: 1.5;
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
    }

    html, body, #root {
      margin: 0;
      height: 100%;
      font-size: var(--normal-text);
      direction: rtl;
    }

    body {
        background: hsl(0deg 0% 100%);
        -webkit-font-smoothing: antialiased;
     }

    body, input, button, select, option {
      color: hsl(0deg 0% 0% / 90%);
      font-family: var(--font-family);
      font-weight: var(--normal-weight);
    }

    * div {
       position: relative;
    }

    ::selection {
      color: white;
      background-color: var(--primary-2);
    }

    @media (orientation: landscape) {
      ::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: var(--gray-3);
          border: 2px solid var(--dark-5);
      }
    }

    a:-webkit-any-link {
      text-decoration: none;
    }
`;

export default GlobalStyle;
